import type { NetworkData } from '@dynamic-labs-sdk/client';
import { createBaseNetworkProvider } from '@dynamic-labs-sdk/client/core';

import type { BitcoinNetworkProvider } from '../../BitcoinNetworkProvider.types';
import { fetchBtcBalance } from '../fetchBtcBalance';

export const createBitcoinNetworkProvider = (
  networkData: NetworkData
): BitcoinNetworkProvider => ({
  ...createBaseNetworkProvider('BTC', networkData),
  cluster: networkData.cluster,
  getBalance: async ({ address }) => ({
    balance: await fetchBtcBalance({
      address,
    }),
  }),
});
